import { NavLink, useLocation } from "react-router-dom";
import React from "react";
import { UserAuth } from "../context/authContext";
import { BiLogOut, BiSearchAlt2, BiHomeAlt, BiBookmarks } from "react-icons/bi";
import { MdInfoOutline } from "react-icons/md";
import { TiDocumentAdd } from "react-icons/ti";
import Logo from "../assets/Logo.png";
import "../style.css";

export default function Navbar() {
  const { logOut } = UserAuth();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };

  const usePathname = () => {
    const location = useLocation();
    return location.pathname;
  };

  return (
    <nav className="nav">
      <NavLink to="/homepage" className="logo">
        <img src={Logo} className="w-10 mx-auto lg:mx-0 text-left" />
      </NavLink>
      <div className="innerNav">
        <CustomLink to="/homepage" data-title="Homepage">
          <BiHomeAlt
            size={35}
            className={
              usePathname() === "/homepage"
                ? "isActive StyledIconFill"
                : "StyledIconFill"
            }
          />
        </CustomLink>
        <CustomLink to="/explore" data-title="Explore">
          <BiSearchAlt2
            size={35}
            className={
              usePathname() == "/explore"
                ? "isActive StyledIconFill"
                : "StyledIconFill"
            }
          />
        </CustomLink>
        <CustomLink to="/bookmarks" data-title="Bookmarks">
          <BiBookmarks
            size={35}
            className={
              usePathname() == "/bookmarks"
                ? "isActive StyledIconFill"
                : "StyledIconFill"
            }
          />
        </CustomLink>
        <CustomLink to="/create-post" data-title="publish new article">
          <TiDocumentAdd
            size={35}
            className={
              usePathname() == "/create-post"
                ? "isActive StyledIconFill"
                : "StyledIconFill"
            }
          />
        </CustomLink>
        <CustomLink to="/AboutUs" data-title="About us">
          <MdInfoOutline
            size={32}
            className={
              usePathname() == "/AboutUs"
                ? "isActive StyledIconFill text-center"
                : "StyledIconFill text-center"
            }
          />
        </CustomLink>
      </div>
      <button
        onClick={handleSignOut}
        className="logOutBtn"
        data-title="Log out"
      >
        <BiLogOut size={35} color={"FE3F3F"} />
      </button>
    </nav>
  );
}

function CustomLink({ to, children, ...props }) {
  return (
    <div>
      <NavLink to={to} {...props}>
        {children}
      </NavLink>
    </div>
  );
}
